import type { RouteRecordRaw } from 'vue-router'

const authRoutes: RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/auth/Login.vue'),
    meta: { hideInMenu: true, layout: 'blank' },
  },
  {
    path: '/unauthorized',
    name: 'Unauthorized',
    component: () => import('@/views/common/Unauthorized.vue'),
    meta: { hideInMenu: true, layout: 'blank' },
  },
]

export default authRoutes
